import { AboutUs, Videos } from 'src/graphql/schema.graphql';
import { gql, GqlFragment } from 'src/utils/gql/query';

export const aboutUsGqlQuery: GqlFragment<{
  aboutUs: AboutUs;
  bannerVideo: Videos[];
}> = gql`
  query {
    aboutUs {
      aboutVideos {
        id
        videos_id {
          id
          slug
          thumbnail {
            id
          }
          tags {
            tags_id {
              id
              translations {
                name
                languages_code {
                  code
                }
              }
            }
          }
          disclaimer
          source {
            id
            url
            format
            duration
          }
          translations {
            name
            languages_code {
              code
            }
          }
        }
      }
      heroVideo {
        id
        slug
        thumbnail {
          id
        }
        disclaimer
        source {
          id
          url
          format
          duration
        }
        translations {
          name
          languages_code {
            code
          }
        }
      }
    }
    bannerVideo: videos(filter: { slug: { _eq: "neauvia-congress" } }) {
      id
      slug
      thumbnail {
        id
      }
      disclaimer
      source {
        id
        url
        format
        duration
      }
      translations {
        name
        languages_code {
          code
        }
      }
    }
  }
`;
